import PaymentResult from "routes/Secure/PaymentResult";
import Certification from "routes/Secure/Certification";
import Payment from "routes/Secure/Payment";

const secureRoutes = [
    {
        path: "secure",
        children: [
            {
                path: "certification",
                element: <Certification />,
            },
            {
                path: "payment",
                element: <Payment />,
            },
            {
                path: "paymentresult",
                element: <PaymentResult />,
            },
        ],
    },
];

export default secureRoutes;
